









import { Component, Vue } from 'vue-property-decorator';
import TaskTemplatesTable from '@/modules/tasks/templates/components/TaskTemplatesTable.vue';
import Card from '@/components/default/Card.vue';

@Component({
  components: {
    TaskTemplatesTable,
    Card,
  },
})
export default class TaskTemplatesOverviewPage extends Vue {

}
